import AccDetails from './AccDetails';
import ChangePassword from './ChangePassword';
import Reservations from './Reservation';
import LinkAccounts from './LinkAccounts';
import AxsSdk from './AxsSdk';
import SendToFriend from './SendToFriend';

export default class Account {
    constructor() {
        this.init();
    }

    init() {
        new AccDetails();
        new ChangePassword();
        new Reservations();
        new LinkAccounts();
        new AxsSdk();
        new SendToFriend();

        const el = document.querySelector('#dashboard-infotext');
        if (el) {
            setTimeout(() => {
                el.style.display = 'none';
            }, 5000);
        }
    }
}